import axios from "axios";
import {url} from "@/service/BASE_URL";

const URL = `${url}/api/auth`;

export default {
  signIn(payload) {
    return axios.post(`${URL}/signin`, payload, {});
  },
  singUp(payload) {
    return axios.post(`${URL}/signup`, payload);
  },
};
